module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/db50bd7dacd69c9e8397eb83b4d83c3b.svg";